// extracted by mini-css-extract-plugin
export default {"counter":"NnAiNH","viewCount":"UkkJQA","commentCount":"WX6uqw","replyCount":"uD6_va"};